module.exports = __webpack_public_path__ + "static/media/KEITH MONKS PRODIGY.1d7b5204.png";